import { createFileRoute } from '@tanstack/react-router'

import { ImportExportPage } from '@/pages/import-export/ImportExport.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/import-export',
)({
  component: ImportExportPage,
  loader: () => ({ breadcrumbTitle: 'Import & Export' }),
})
